<template>
  <div class="shipmentocean">
    <form v-on:submit.prevent="ButtonNext(tabIndex)">
      <div class="row m-0 navigation">
        <b-button-group class="row mx-0 px-4 navigation">
          <b-button @click="ButtonPrev">
            <img  src = "@/assets/image/icon/icon-rectangle.svg">
            Back
          </b-button>
          <b-button type="submit">
            Next
            <img  src = "@/assets/image/icon/icon-rectangle.svg">
          </b-button>
        </b-button-group>
      </div>
      <div class="shipmentocean__tabs" style="max-width:907px">
        <b-card no-body>
          <b-tabs v-model="tabIndex" align="center">
            <b-tab title="FCL" :title-link-class="linkClass(0)">
              <HeaderShipmentType :dataHeader="currentDataHeader('FCL')"
                                   v-if="this.tabIndex === 0" />
              <div class="shipmentocean__tabs--contain" v-if="this.tabIndex === 0">
                <FCL
                  @inputData="pushData"
                  :showErrorFCL="this.header.subtitle === 'FCL' ? errors.items : null"
                  :selectedTab="this.header.subtitle"
                />
              </div>
            </b-tab>
            <b-tab title="LCL" :title-link-class="linkClass(1)">
              <LCL
                v-if="this.tabIndex === 1"
                @inputData="pushData"
                @errorInputLCL="errorInputLCL"
              />
            </b-tab>
            <div v-if="showErrorWeightOrVolume" class="fontstyle__errormsg">
              Weight or Volume is out of range. Maximal Weight or Volume is 9999999
            </div>
          </b-tabs>
        </b-card>
      </div>
    </form>
  </div>
</template>

<script>
import HeaderShipmentType from '@/components/contract/components/HeaderShipmentType'
import FCL from './ShipmentType/FCL'
import LCL from './ShipmentType/LCL'

export default {
  name: 'shipment_ocean',
  components: {
    FCL,
    LCL,
    HeaderShipmentType
  },
  provide () {
    return { parentValidator: this.$validator }
  },
  data () {
    return {
      tabIndex: 0,
      header: {
        id: 1,
        subtitle: 'FCL'
      },
      data: {
      },
      totalUnit: 0,
      totalVolume: 0,
      totalWeight: 0,
      showErrorLCL: true,
      showErrorWeightOrVolume: false,
      errorCalkFCL: false
    }
  },
  methods: {
    linkClass (idx) {
      if (this.tabIndex === idx) {
        return ['selectedtab']
      } else {
        return ['blocktab']
      }
    },

    chooseOcean (idx) {
      let oceanType = ''
      if (idx === 0) {
        oceanType = 'FCL'
      } else if (idx === 1) {
        oceanType = 'LCL'
      }
      this.header.subtitle = oceanType
      this.resetHeaderCalculateInfo()
      this.showErrorWeightOrVolume = false
      this.$emit('chgHeader', this.header)
    },

    resetHeaderCalculateInfo () {
      //
    },

    currentDataHeader (type) {
      let data = {}
      if (type === 'FCL') {
        data = {
          shipmenttype: 'FCL',
          img: require('@/assets/image/icon/icon-ocean-fcl.svg'),
          text: 'Get the best rates for your shipment to all around the world with FCL services.',
          shipmentTotal: null
        }
      }
      return data
    },

    errorInputLCL (status) {
      this.showErrorLCL = status.errorsLCL
    },

    pushData (payload) {
      if (payload) {
        if (payload.total_weight <= payload.totalshipment) {
          this.errorCalkFCL = true
        } else {
          this.errorCalkFCL = false
        }

        if (payload.totalWeightPerShipment) {
          if (payload.totalWeightPerShipment > 9999999) {
            this.showErrorWeightOrVolume = true
          } else {
            this.showErrorWeightOrVolume = false
          }
        }
      }
      this.$emit('inputData', payload)
    },

    ButtonNext () {
      if (this.header.subtitle === 'FCL') {
        this.$validator.validateAll(this.parentValidator).then((result) => {
          if (result && !this.errorCalkFCL) {
            this.$validator.reset()
            this.pushData()
            this.$emit('tabIndex')
          } else {
            console.log('error required field')
          }
        })
      } else {
        this.$validator.reset()
        if (!this.showErrorLCL && !this.showErrorWeightOrVolume) {
          this.pushData()
          this.$emit('tabIndex')
        }
      }
    },

    ButtonPrev () {
      this.$emit('tabIndexPrev')
    }
  },
  mounted () {
    this.$emit('chgHeader', this.header)
  },
  watch: {
    tabIndex (idx) {
      this.chooseOcean(idx)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/contract/ShipmentOcean.vue